import '@/styles/main.css';

import { createPinia } from 'pinia';
import { createApp } from 'vue';

import App from './App.vue';
import { sonik } from './integrations/sonik';
import { VueQueryPlugin, vueQueryPluginOptions } from './integrations/vueQuery';
import { store } from './integrations/vuex';
import router, { initDocumentTitle } from './router';
import { useUiStore } from './stores/ui';

export const app = createApp(App);

const pinia = createPinia();

app.use(pinia);
useUiStore().initColorScheme();
app.use(store);
app.use(router);
initDocumentTitle();
app.use(sonik);
app.use(VueQueryPlugin, vueQueryPluginOptions);

app.mount('#app');

export default app;
